import $ from 'jquery';
import _ from 'underscore';
import Backbone from "backbone";
import React from "react";
import { createRoot } from "react-dom/client";
import HomeMenuTemplate from 'text!../../../templates/homeMenuPanel/HomeMenuPanelTemplate.html';
import ti18n from 'i18n!nls/HomeMenuPaneli18n';
import WorkspaceSwitcher from "../../components/workspace/WorkspaceSwitcher";
import "./styles.css";

const USER_PROFILE_IMAGE_WIDTH = 50;
const USER_PROFILE_IMAGE_HEIGHT = 50;
const HomeMenuPanelView = Backbone.View.extend({

    template : _.template(HomeMenuTemplate),

    initialize : function(options) {
        this._selectedMenuId  = null;
        this._userInfo =options? options.userInfo : null;
        this._isUserAllowToSetupTrebble = options? options.isUserAllowToSetupTrebble: false;
        this._isUserAllowToCreateFirstJourney = options? options.isUserAllowToCreateFirstJourney: false;
        this._isOpen = false
    },

    events : {
        "click #projectsBtn" : "showProjectsPage",
        "click #myLibraryBtn" : "showLibraryPage",
        "click #myLibrary2Btn" : "showLibrary2Page",
        "click #transcribedFilesBtn" : "showTranscribedFilesPage",
        "click #editHistoryBtn" : "showEditHistoryPage",
        "click #assetsBtn" : "showAssetsPage",
        "click #recordingsBtn" : "showRecordingsPage",
        "click #searchBtn" : "showGlobalSearch",
        "click #helpAndFeedbackBtn" : "showHelpAndFeedback",
        "click #trebblesBtn" : "showTrebblesPage",
        "click #mySubscriptionsBtn" : "showMySubscriptionsPage",
        "click #myJourneysBtn" : "showMyJourneysPage",
        "click #homeBtn" : "showHomePage",
        "click #onAirBtn" : "showOnAirPage",
        "click .loggedInUserInfoBox > .userCoverArtWrapper" : "showLoggedInUserPage",
        "click #feedsAndNotificationBtn" : "showfeedsAndNotificationPage",
        "click #settingBtn" : "showSettingsPage",
        "click #exploreBtn" : "showExplorePage",
        "click #capsulesBtn" : "showCapsulesPage",
        "click #referBtn": "showReferPage",
        "click #sharedWithMeBtn": "showSharedWithMePage",
        "click #downloadExtensionBtn": "installChromeExtension",
        "click #createMyOwnTrebbleBtn":"createMyOwnTrebble",
        "click #createMyFirstJourneyBtn":"createMyFirstJourney",
        "click #installPWABtn": "installWPA",
        "click #upgradeBtn": "showUpgradeToPaidSubscriptionPopup",
        "click #createWorkspaceBtn": "showCreateWorkspace",
        "click #helpBtn" : "showHelpPage",
    },

    toggle : function(){
        /*if(this._isOpen){
            this.$el.panel("close");
        }else{
            this.$el.panel("open");
        }*/
        this.$el.panel("toggle");
    },

    onAnalyseAudioPlayingBtnTapped : function(ev){
        this.trigger("analyseAudioOutput");
    },

    showLibraryPage : function(ev){
        this._updateSelectedMenu(ev);
        this.trigger("showLibraryPage");
    },

    showProjectsPage : function(ev){
        this._updateSelectedMenu(ev);
        this.trigger("showProjectsPage");
    },

    showLibrary2Page : function(ev){
        this._updateSelectedMenu(ev);
        this.trigger("showLibrary2Page");
    },

    showAssetsPage : function(ev){
        this._updateSelectedMenu(ev);
        this.trigger("showAssetsPage");
    },

    showRecordingsPage : function(ev){
        this._updateSelectedMenu(ev);
        this.trigger("showRecordingsPage");
    },

    showRecordingsMenuBtn : function(){
        this.$el.find("#recordingsBtn").removeClass("hide");
        this.$el.find("#recordingsBtn").css('display', 'flex');
    },

    hideRecordingsMenuBtn : function(){
        this.$el.find("#recordingsBtn").addClass("hide");
    },

    showTranscribedFilesPage : function(ev){
        this._updateSelectedMenu(ev);
        this.trigger("showTranscribedFilesPage");
    },

    showEditHistoryPage : function(ev){
        this._updateSelectedMenu(ev);
        this.trigger("showEditHistoryPage");
    },


    showReferPage : function(ev){
        this._updateSelectedMenu(ev);
        this.trigger("showReferPage");
    },

    showSharedWithMePage : function(ev){
        this._updateSelectedMenu(ev);
        this.trigger("showSharedWithMePage");
    },

    showSharedWithMeMenuBtn : function(){
        this.$el.find("#sharedWithMeBtn").removeClass("hide");
        this.$el.find("#sharedWithMeBtn").css('display', 'flex');
    },

    hideSharedWithMeMenuBtn : function(){
        this.$el.find("#sharedWithMeBtn").addClass("hide");
    },

    showWorkspaceSwitcher : function(workspaces, activeWorkspaceId, onSwitch, onNewWorkspace, newWorkspaceLabel){
        this._workspaceSwitcherData = {
            workspaces: workspaces,
            activeWorkspaceId: activeWorkspaceId,
            onSwitch: onSwitch,
            onNewWorkspace: onNewWorkspace,
            newWorkspaceLabel: newWorkspaceLabel
        };
        var container = this.$el.find("#workspaceSwitcherContainer");
        container.removeClass("hide");
        this._renderWorkspaceSwitcher();
    },

    hideWorkspaceSwitcher : function(){
        var container = this.$el.find("#workspaceSwitcherContainer");
        container.addClass("hide");
        if(this._workspaceSwitcherRoot){
            this._workspaceSwitcherRoot.unmount();
            this._workspaceSwitcherRoot = null;
        }
        this._workspaceSwitcherData = null;
    },

    updateWorkspaceSwitcher : function(workspaces, activeWorkspaceId, onSwitch, newWorkspaceLabel){
        this._workspaceSwitcherData = Object.assign({}, this._workspaceSwitcherData, {
            workspaces: workspaces,
            activeWorkspaceId: activeWorkspaceId,
            onSwitch: onSwitch,
            newWorkspaceLabel: newWorkspaceLabel
        });
        this._renderWorkspaceSwitcher();
    },

    _hydrateWorkspaceSwitcherFromLocalStorage : function(){
        if(!this._workspaceSwitcherData || typeof window === "undefined"){
            return;
        }
        try {
            var storage = window.localStorage;
            if(!storage){
                return;
            }
            var currentWorkspaceId = storage.getItem("currentWorkspaceId");
            var rawWorkspaceContext = storage.getItem("workspaceContext");
            var rawWorkspaceList = storage.getItem("workspaceList");
            var workspaceContext = rawWorkspaceContext ? JSON.parse(rawWorkspaceContext) : null;
            var storedWorkspaceList = rawWorkspaceList ? JSON.parse(rawWorkspaceList) : [];
            if(!Array.isArray(storedWorkspaceList)){
                storedWorkspaceList = [];
            }
            // Preserve any server-provided workspace list already on
            // _workspaceSwitcherData; only fall back to storage when there
            // is no server-backed list yet.
            var existingWorkspaces = (this._workspaceSwitcherData && this._workspaceSwitcherData.workspaces) || [];
            var hasServerWorkspaces = Array.isArray(existingWorkspaces) && existingWorkspaces.length > 0;
            var workspaces = hasServerWorkspaces ? existingWorkspaces.slice() : storedWorkspaceList.slice();
            if(workspaceContext && workspaceContext.workspaceId){
                var hasWorkspaceContext = workspaces.some(function(workspace){
                    return workspace && workspace.workspaceId === workspaceContext.workspaceId;
                });
                if(!hasWorkspaceContext){
                    workspaces.push(workspaceContext);
                }
                currentWorkspaceId = workspaceContext.workspaceId;
            }
            if(!currentWorkspaceId && workspaces.length){
                var lastSelectedWorkspace = workspaces.find(function(workspace){
                    return workspace && workspace.isLastSelectedWorkspace && workspace.workspaceId;
                });
                if(lastSelectedWorkspace){
                    currentWorkspaceId = lastSelectedWorkspace.workspaceId;
                }
            }
            if(currentWorkspaceId){
                this._workspaceSwitcherData = Object.assign({}, this._workspaceSwitcherData, {
                    workspaces: workspaces,
                    activeWorkspaceId: currentWorkspaceId
                });
            }
        } catch (error) {
            // Keep the previously-rendered switcher data if storage is not readable.
        }
    },

    _renderWorkspaceSwitcher : function(){
        if(!this._workspaceSwitcherData){
            return;
        }
        this._hydrateWorkspaceSwitcherFromLocalStorage();
        var container = this.$el.find("#workspaceSwitcherContainer").get(0);
        if(!container){
            return;
        }
        if(!this._workspaceSwitcherRoot){
            this._workspaceSwitcherRoot = createRoot(container);
        }
        this._workspaceSwitcherRoot.render(
            React.createElement(WorkspaceSwitcher, {
                workspaces: this._workspaceSwitcherData.workspaces,
                activeWorkspaceId: this._workspaceSwitcherData.activeWorkspaceId,
                onSwitch: this._workspaceSwitcherData.onSwitch,
                onNewWorkspace: this._workspaceSwitcherData.onNewWorkspace,
                myProjectsLabel: window.getI18n(ti18n, "PERSONAL_SPACE"),
                newWorkspaceLabel: this._workspaceSwitcherData.newWorkspaceLabel || window.getI18n(ti18n, "NEW_WORKSPACE")
            })
        );
    },

    installChromeExtension: function(){
        this.trigger("installChromeExtension");
        this.$el.panel("close");
    },

    installWPA: function(){
        this.trigger("installWPA");
        this.$el.panel("close");
    },
    
    showUpgradeToPaidSubscriptionPopup : function(){
        this.trigger("showUpgradeToPaidSubscriptionPopup");
        this.$el.panel("close");
    },

    showCreateWorkspace : function(){
        this.trigger("showCreateWorkspace");
        this.$el.panel("close");
    },

    createMyOwnTrebble : function(){
        this.trigger("createMyOwnTrebble");
        this.$el.panel("close");
    },

    createMyFirstJourney : function(){
        this.trigger("createMyFirstJourney");
        this.$el.panel("close");
    },

    showUpgradeBtn : function(){
        this.$el.find("#upgradeBtn").css('display', 'flex');
    },

    hideUpgradeBtn : function(){
        this.$el.find("#upgradeBtn").css('display', 'none');
    },

    showCreateWorkspaceBtn : function(){
        this.$el.find("#createWorkspaceBtn").css('display', 'flex');
    },

    hideCreateWorkspaceBtn : function(){
        this.$el.find("#createWorkspaceBtn").css('display', 'none');
    },

    setWorkspaceContextLabel : function(label){
        var $label = this.$el.find(".workspaceContextLabel");
        if(label){
            $label.text(label);
            $label.removeClass("hide");
        } else {
            $label.addClass("hide");
            $label.text("");
        }
    },

    showMyJourneysBtn : function(){
        this.$el.find("#myJourneysBtn").css('display', 'flex');
    },

    hideMyJourneysBtn : function(){
        this.$el.find("#myJourneysBtn").css('display', 'none');
    },

    setWorkspaceOff : function(){
        this.$el.find(".homePanelLayout").addClass("workspace-off");
    },

    showLegacyMenuItems : function(){
        this.$el.find("#legacyMenuItems").show();
    },

    hideLegacyMenuItems : function(){
        this.$el.find("#legacyMenuItems").hide();
    },

    showHomeBtn : function(){
        this.$el.find("#homeBtn").css('display', 'flex');
    },

    hideHomeBtn : function(){
        this.$el.find("#homeBtn").css('display', 'none');
    },

    showMyLibraryBtn : function(){
        this.$el.find("#myLibraryBtn").css('display', 'flex');
    },

    hideMyLibraryBtn : function(){
        this.$el.find("#myLibraryBtn").css('display', 'none');
    },

    showMyLibrary2Btn : function(){
        this.$el.find("#myLibrary2Btn").css('display', 'flex');
    },

    hideMyLibrary2Btn : function(){
        this.$el.find("#myLibrary2Btn").css('display', 'none');
    },

    showMySubscriptionsBtn : function(){
        this.$el.find("#mySubscriptionsBtn").css('display', 'flex');
    },

    hideMySubscriptionsBtn : function(){
        this.$el.find("#mySubscriptionsBtn").css('display', 'none');
    },

    showExploreBtn : function(){
        this.$el.find("#exploreBtn").css('display', 'flex');
    },

    hideExploreBtn : function(){
        this.$el.find("#exploreBtn").css('display', 'none');
    },

    showSearchBtn : function(){
        this.$el.find("#searchBtn").css('display', 'flex');
    },

    hideSearchBtn : function(){
        this.$el.find("#searchBtn").css('display', 'none');
    },

    showProjectsBtn : function(){
        this.$el.find("#projectsBtn").css('display', 'flex');
    },

    hideProjectsBtn : function(){
        this.$el.find("#projectsBtn").css('display', 'none');
    },

    showTranscribedFilesBtn : function(){
        this.$el.find("#transcribedFilesBtn").css('display', 'flex');
    },

    hideTranscribedFilesBtn : function(){
        this.$el.find("#transcribedFilesBtn").css('display', 'none');
    },

    showEditHistoryBtn : function(){
        this.$el.find("#editHistoryBtn").css('display', 'flex');
    },

    hideEditHistoryBtn : function(){
        this.$el.find("#editHistoryBtn").css('display', 'none');
    },

    showAssetsBtn : function(){
        this.$el.find("#assetsBtn").css('display', 'flex');
    },

    hideAssetsBtn : function(){
        this.$el.find("#assetsBtn").css('display', 'none');
    },

    showInstallWPABtn : function(){
        this.$el.find("#installPWABtn").show();
    },

    hideInstallWPABtn : function(){
        this.$el.find("#installPWABtn").hide();
    },

    showReferUserMenuBtn :function(){
        this.$el.find("#referBtn").hide();
    },

    hideReferUserMenuBtn :function(){
        this.$el.find("#referBtn").hide();
    },

    

    hideHelpAndFeedbackMenuBtn :function(){
        this.$el.find("#helpAndFeedbackBtn").hide();
    },

    updateUserInfo : function(newUserInfo, doNotAddTimestampToUrl){
        this._userInfo  = newUserInfo;
        if(this.$el){
            const usernameString = newUserInfo?newUserInfo.getUsername(): window.getI18n(ti18n, "SIGN_IN");
            this.$el.find(".username.itemTitle").html(usernameString);
            const profileImageUrl = newUserInfo? newUserInfo.getProfileImageUrl(): null;
            //profileImageUrl =  (profileImageUrl && !doNotAddTimestampToUrl)?profileImageUrl + "?random="+ (new Date()).getTime(): profileImageUrl;
            if(profileImageUrl){
                //const resizeImageUrl = window.trebble.globalHelpers.getResizeImageUrl(profileImageUrl, USER_PROFILE_IMAGE_WIDTH, USER_PROFILE_IMAGE_HEIGHT);
                this.$el.find("#userProfileImage").css("background-image","url("+window.trebble.globalHelpers.getResizeImageUrl(profileImageUrl, 50,50 )+")");
                this.$el.find("#userProfileImage > .pe-7s-smile").hide();
            }else{
                this.$el.find("#userProfileImage").css("background-image","url(none)");
                this.$el.find("#userProfileImage > .pe-7s-smile").show();
            }
        }
    },

    setAllNotificationRead : function(allNotificationRead){
        if(allNotificationRead){
            this.$el.find(".menuIcon.pe-7s-bell > .ownerDataBubble").removeClass("unread");
        }else{
            this.$el.find(".menuIcon.pe-7s-bell > .ownerDataBubble").addClass("unread");
        }
    },

    setHelpDisplayedAtLeastOnceToUser: function(helpDisplayedOnceToUser){
        if(helpDisplayedOnceToUser){
            this.$el.find(".menuIcon.pe-7s-help2 > .ownerDataBubble").removeClass("unread");
        }else{
            this.$el.find(".menuIcon.pe-7s-help2 > .ownerDataBubble").addClass("unread");
        }
    },

    setUnreadMessagesInHelpSection: function(unreadMessages){
        if(unreadMessages){
            this.$el.find(".menuIcon.pe-7s-help1 > .ownerDataBubble").addClass("unread");
        }else{
            this.$el.find(".menuIcon.pe-7s-help1 > .ownerDataBubble").removeClass("unread");
        }
    },


    showGlobalSearch : function(ev){
        this._updateSelectedMenu(ev);
        this.trigger("showGlobalSearch");
    },


    showHelpAndFeedback : function(ev){
        //this._updateSelectedMenu(ev);
        this.trigger("showHelpAndFeedback");
        this.$el.panel("close");
    },

    showExplorePage : function(ev){
        this._updateSelectedMenu(ev);
        this.trigger("showExplorePage");
    },

    showTrebblesPage : function(ev){
        this._updateSelectedMenu(ev);
        this.trigger("showTrebblesPage");
    },

    showMySubscriptionsPage : function(ev){
        this._updateSelectedMenu(ev);
        this.trigger("showMySubscriptionsPage");
    },

    showMyJourneysPage : function(ev){
        this._updateSelectedMenu(ev);
        this.trigger("showMyJourneysPage");
    },

    showHomePage : function(ev){
        this._updateSelectedMenu(ev);
        this.trigger("showHomePage");
    },
    
    /*
    showHomePage : function(ev){
        //this._updateSelectedMenu(ev);
        this.trigger("showHomePage");
    },*/

    showHelpPage : function(ev){
        //this._updateSelectedMenu(ev);
        this.trigger("showHelpPage");
    },


    showOnAirPage : function(ev){
        //this._updateSelectedMenu(ev);
        this.trigger("showOnAirPage");
    },

    showLoggedInUserPage : function(ev){
        //this._updateSelectedMenu(ev);
        this.trigger("showLoggedInUserPage");
    },

    showfeedsAndNotificationPage  : function(ev){
        //this._updateSelectedMenu(ev);
        this.trigger("showfeedsAndNotificationPage");
    },

    showCapsulesPage : function(ev){
        //this._updateSelectedMenu(ev);
        this.trigger("showCapsulesPage");
    },

    showSettingsPage : function(ev){
        //this._updateSelectedMenu(ev);
        this.trigger("showSettingsPage");
    },


    onBeforeRemoveFromPage : function(){
        this.trigger("beforeRemoveFromPage", this);
    },

    onRemovedFromPage : function(){
        if (this._workspaceSwitcherRoot) {
            this._workspaceSwitcherRoot.unmount();
            this._workspaceSwitcherRoot = null;
        }
        this._workspaceSwitcherData = null;
        this.undelegateEvents();
        this.$el.removeData().unbind();
        this.trigger("removedFromPage", this);
    },

    _updateSelectedMenu : function(event){
        const newSelectedMenuId = event.currentTarget.id;
        this._updateSelectedMenuByMenuId(newSelectedMenuId);
    },

    _updateSelectedMenuByMenuId : function(newSelectedMenuId){
        this.$el.find("#"+this._selectedMenuId).removeClass("selected");
        this.$el.find("#"+newSelectedMenuId).addClass("selected");
        this._selectedMenuId = newSelectedMenuId;
    },

    setProjectsPageAsSelectedMenu : function(){
        this._updateSelectedMenuByMenuId("projectsBtn");
    },

    setAssetsPageAsSelectedMenu : function(){
        this._updateSelectedMenuByMenuId("assetsBtn");
    },

    setRecordingsPageAsSelectedMenu : function(){
        this._updateSelectedMenuByMenuId("recordingsBtn");
    },

    setMyLibraryPageAsSelectedMenu : function(){
        this._updateSelectedMenuByMenuId("myLibraryBtn");
    },

    setReferPageAsSelectedMenu : function(){
        this._updateSelectedMenuByMenuId("referBtn");
    },

    setTrebblesPageAsSelectedMenu : function(){
        this._updateSelectedMenuByMenuId("trebblesBtn");
    },

    setSearchPageAsSelectedMenu : function(){
        this._updateSelectedMenuByMenuId("searchBtn");
    },

    setHelpAndFeedbackPageAsSelectedMenu : function(){
        this._updateSelectedMenuByMenuId("helpAndFeedbackBtn");
    },

    hideHomeMenu : function(){
        this.$el.find("#homeBtn").hide();
    },


    setOnAirPageAsSelectedMenu : function(){
        this._updateSelectedMenuByMenuId("onAirBtn");
    },

    setSettingsPageAsSelectedMenu : function(){
        this._updateSelectedMenuByMenuId("settingBtn");
    },

    setUserInfoPageAsSelectedMenu : function(){
        this._updateSelectedMenuByMenuId("loggedInUserBtn");
    },

    setExplorePageAsSelectedMenu : function(){
        this._updateSelectedMenuByMenuId("exploreBtn");
    },

    setMySubsciptionsPageAsSelectedMenu : function(){
        this._updateSelectedMenuByMenuId("mySubscriptionsBtn");
    },

    setMyJourneysPageAsSelectedMenu : function(){
        this._updateSelectedMenuByMenuId("myJourneysBtn");
    },

    setSharedWithMePageAsSelectedMenu : function(){
        this._updateSelectedMenuByMenuId("sharedWithMeBtn");
    },

    setTranscribedFilesPageAsSelectedMenu : function(){
        this._updateSelectedMenuByMenuId("transcribedFilesBtn");
    },

    setEditHistoryPageAsSelectedMenu : function(){
        this._updateSelectedMenuByMenuId("editHistoryBtn");
    },

    setHomePageAsSelectedMenu : function(){
        this._updateSelectedMenuByMenuId("homeBtn");
    },

    setFeedAndNotificationsPageAsSelectedMenu : function(){
        this._updateSelectedMenuByMenuId("feedsAndNotificationBtn");
    },

    setCapsulesPageAsSelectedMenu : function(){
        this._updateSelectedMenuByMenuId("capsulesBtn");
    },

    setHelpPageAsSelectedMenu : function(){
        this._updateSelectedMenuByMenuId("helpBtn");
    },
    _onPanelOpen : function(){
        this._isOpen = true;
        this._hydrateWorkspaceSwitcherFromLocalStorage();
        this._renderWorkspaceSwitcher();
        this.trigger("panelOpened");
    },

    _onPanelClose : function(){
        this._isOpen = false;
        this.trigger("panelClosed");
    },
    render : function(){
        this.$el.html(this.template({"ti18n": ti18n}));
        this.setElement(this.$el.find("div").first());
        const panelStyle = "overlay";
        /*if(window.device && window.device.platform == "browser"){
            panelStyle ="push";
        }*/
        $('body').append(this.$el);
        this.$el.panel({ open: this._onPanelOpen.bind(this),  close: this._onPanelClose.bind(this), "display": panelStyle });
        /*if(window.device && window.device.platform == "browser"){
            this.$el.panel("open");
            this._isOpen = true;
        }*/
        if(this._isUserAllowToSetupTrebble){
            //Adding this class will allow the button to be displayed because of the css
            //this.$el.find("#createMyOwnTrebbleBtn").addClass("forceDisplay");
        }
        if(this._isUserAllowToCreateFirstJourney){
            //Adding this class will allow the button to be displayed because of the css
            this.$el.find("#createMyFirstJourneyBtn").addClass("forceDisplay");
        }
        this.updateUserInfo(this._userInfo, true);
        this.$el.find("#projectsBtn").addClass("selected");
        this._selectedMenuId = "projectsBtn";
        return this;
    },

});
export default HomeMenuPanelView;
